import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Alert, Col, FormGroup, Input, Label } from 'reactstrap';
import MultiInput from './MultiInput';
import DropdownSelect from './ProposalGenerator/DropdownSelect';
import util from '../lib/utils';
import {
  addCompanyGroupChange,
  getCompanyGroupManager,
  getSupportEngineers,
} from '../actions/Companies';
import { addEmailFieldChange, addNumberFieldChange, getCompanyNumbers } from '../actions/Numbers';
import CompanyAutocomplete from './CompanyAutocomplete';
import UsersAutocomplete from './Numbers/UsersAutocomplete';
const groupItems = [
  { label: '', value: '' },
  { label: 'CSG', value: 'CSG' },
  { label: 'Granite', value: 'Granite' },
  { label: 'Bullseye', value: 'Bullseye' },
];

class AddCompanyGroupForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: [],
      groupAdmins: [],
      groupManagers: [],
      supportEngineers: [],
      hostTag: groupItems[0],
      notificationMails: [],
    };
    this.token = localStorage.getItem('jwtToken');
  }

  componentDidMount() {
    this.props.addCompanyGroupChange({ name: 'hostTag', value: groupItems[0].value });
  }

  handleChange = ev => {
    const { name, value } = ev.target;
    this.setState({ [name]: value });
    this.props.addCompanyGroupChange({ name, value });
  };

  onManagerSelect = numberType => {
    const number = numberType ? numberType?.value : '';

    if (numberType?.value !== undefined && numberType?.value !== null && numberType?.value !== '') {
      var adminFound = this.state.groupManagers;
      var found = false;
      if (adminFound.length > 0) {
        adminFound.forEach((i, idx, x) => {
          if (i.email && i.email.email && i.email.email === numberType?.value.email) {
            found = true;
          } else if (i.email === numberType?.value.email) {
            found = true;
          }
          if (idx === x.length - 1) {
            if (found === false) {
              this.props.addNumberFieldChange('assignedTo', {
                email: number,
                _id: this.props.user._id,
              });
              var value = this.state.groupManagers.concat({
                email: number,
                _id: this.props.user._id,
              });
              this.setState({ groupManagers: value }, () => {
                this.props.addCompanyGroupChange({
                  name: 'groupManagers',
                  value: this.state.groupManagers,
                });
              });
            } else {
              toast.error('Group Manager already selected');
            }
          }
        });
      } else {
        this.props.addNumberFieldChange('assignedTo', {
          email: number,
          _id: this.props.user._id,
        });
        var value = this.state.groupManagers.concat({
          email: number,
          _id: this.props.user._id,
        });
        this.setState({ groupManagers: value }, () => {
          this.props.addCompanyGroupChange({
            name: 'groupManagers',
            value: this.state.groupManagers,
          });
        });
      }
    }
  };

  onUserTypeSelect = numberType => {
    const number = numberType ? numberType?.value : '';

    if (numberType?.value !== undefined && numberType?.value !== null && numberType?.value !== '') {
      var adminFound = this.state.groupAdmins;
      var found = false;
      if (adminFound.length > 0) {
        adminFound.forEach((i, idx, x) => {
          if (i.email && i.email.email && i.email.email === numberType?.value.email) {
            found = true;
          } else if (i.email === numberType?.value.email) {
            found = true;
          }
          if (idx === x.length - 1) {
            if (found === false) {
              this.props.addNumberFieldChange('assignedTo', {
                email: number,
                _id: this.props.user._id,
              });
              var value = this.state.groupAdmins.concat({
                email: number,
                _id: this.props.user._id,
              });
              this.setState({ groupAdmins: value }, () => {
                this.props.addCompanyGroupChange({
                  name: 'groupSuperAdmins',
                  value: this.state.groupAdmins,
                });
              });
            } else {
              toast.error('Group Admin already selected');
            }
          }
        });
      } else {
        this.props.addNumberFieldChange('assignedTo', {
          email: number,
          _id: this.props.user._id,
        });
        var value = this.state.groupAdmins.concat({
          email: number,
          _id: this.props.user._id,
        });
        this.setState({ groupAdmins: value }, () => {
          this.props.addCompanyGroupChange({
            name: 'groupSuperAdmins',
            value: this.state.groupAdmins,
          });
        });
      }
    }
  };

  onSupportTypeSelect = numberType => {
    const number = numberType ? numberType?.value : '';

    if (numberType?.value !== undefined && numberType?.value !== null && numberType?.value !== '') {
      if (numberType.suggestion.group && numberType.suggestion.group !== null) {
        toast.error(numberType.suggestion.email + ' already exist in another group');
      } else {
        var adminFound = this.state.supportEngineers;
        var found = false;
        if (adminFound.length > 0) {
          adminFound.forEach((i, idx, x) => {
            if (i.email && i.email.email && i.email.email === numberType?.value.email) {
              found = true;
            } else if (i.email === numberType?.value.email) {
              found = true;
            }
            if (idx === x.length - 1) {
              if (found === false) {
                this.props.addNumberFieldChange('assignedTo', {
                  email: number,
                  _id: this.props.user._id,
                });
                var value = this.state.supportEngineers.concat({
                  email: number,
                  _id: this.props.user._id,
                });
                this.setState({ supportEngineers: value }, () => {
                  this.props.addCompanyGroupChange({
                    name: 'supportEngineers',
                    value: this.state.supportEngineers,
                  });
                });
              } else {
                toast.error('Support Engineer already selected');
              }
            }
          });
        } else {
          this.props.addNumberFieldChange('assignedTo', {
            email: number,
            _id: this.props.user._id,
          });
          var value = this.state.supportEngineers.concat({
            email: number,
            _id: this.props.user._id,
          });
          this.setState({ supportEngineers: value }, () => {
            this.props.addCompanyGroupChange({
              name: 'supportEngineers',
              value: this.state.supportEngineers,
            });
          });
        }
      }
    }
  };

  textSearchFilter = async e => {
    if (e.value !== null) {
      if (e.suggestion.companyGroup && e.suggestion.companyGroup !== null) {
        toast.error(e.suggestion.name + ' already exist in another group');
      } else {
        var companyFound = this.state.companies;
        var found = false;
        if (companyFound.length > 0) {
          companyFound.forEach((i, idx, x) => {
            if (i.value === e.value) {
              found = true;
            }
            if (idx === x.length - 1) {
              if (found === false) {
                var value = this.state.companies.concat(e);
                this.setState({ companies: value }, () => {
                  this.props.addCompanyGroupChange({
                    name: 'managedCompanies',
                    value: this.state.companies,
                  });
                });
              } else {
                toast.error('Company already selected');
              }
            }
          });
        } else {
          var value = this.state.companies.concat(e);
          this.setState({ companies: value }, () => {
            this.props.addCompanyGroupChange({
              name: 'managedCompanies',
              value: this.state.companies,
            });
          });
        }
      }
    }
  };

  removeEmails = index => {
    const { companyGroupData } = this.props;
    const valuesWIthRemoved = companyGroupData.groupSuperAdmins.filter((val, ind) => ind !== index);
    this.setState({ groupAdmins: valuesWIthRemoved });
    this.props.addCompanyGroupChange({ name: 'groupSuperAdmins', value: valuesWIthRemoved });
  };

  removeManagerEmails = index => {
    const { companyGroupData } = this.props;
    const valuesWIthRemoved = companyGroupData.groupManagers.filter((val, ind) => ind !== index);
    this.setState({ groupManagers: valuesWIthRemoved });
    this.props.addCompanyGroupChange({ name: 'groupManagers', value: valuesWIthRemoved });
  };

  removeValue = index => {
    const { companyGroupData } = this.props;
    const valuesWIthRemoved = companyGroupData.managedCompanies.filter((val, ind) => ind !== index);
    this.setState({ companies: valuesWIthRemoved });
    this.props.addCompanyGroupChange({ name: 'managedCompanies', value: valuesWIthRemoved });
  };

  renderEmails = () => {
    const { companyGroupData } = this.props;

    return companyGroupData.groupSuperAdmins.map((item, ind) => {
      return (
        <div className="multi-input-item" key={item.email.email}>
          <span className="item">{item.email.email}</span>
          <FontAwesomeIcon
            icon="window-close"
            size="sm"
            title="Remove Notification Email"
            color="#999"
            mask={['far', 'circle']}
            onClick={() => this.removeEmails(ind)}
          />
        </div>
      );
    });
  };

  renderSupport = () => {
    const { supportEngineers } = this.state;
    return supportEngineers.map((item, ind) => {
      return (
        <div className="multi-input-item" key={item.email.email || item.email}>
          <span className="item">{item.email.email || item.email}</span>
          <FontAwesomeIcon
            icon="window-close"
            size="sm"
            title="Remove Notification Email"
            color="#999"
            mask={['far', 'circle']}
            onClick={() => this.removeSupportEngineer(ind)}
          />
        </div>
      );
    });
  };

  renderManagerEmails = () => {
    const { companyGroupData } = this.props;

    return companyGroupData.groupManagers.map((item, ind) => {
      return (
        <div className="multi-input-item" key={item.email.email}>
          <span className="item">{item.email.email}</span>
          <FontAwesomeIcon
            icon="window-close"
            size="sm"
            title="Remove Notification Email"
            color="#999"
            mask={['far', 'circle']}
            onClick={() => this.removeManagerEmails(ind)}
          />
        </div>
      );
    });
  };

  renderCompanies = () => {
    const { companyGroupData } = this.props;

    return companyGroupData.managedCompanies.map((item, ind) => {
      return (
        <div className="multi-input-item" key={item.value}>
          <span className="item">{item.value}</span>
          <FontAwesomeIcon
            icon="window-close"
            size="sm"
            title="Remove Notification Email"
            color="#999"
            mask={['far', 'circle']}
            onClick={() => this.removeValue(ind)}
          />
        </div>
      );
    });
  };

  onAddedCompanyChange = async ({ name, value, suggestion }) => {
    const { addEmailFieldChange, addNumberFieldChange, user, addCompanyGroupChange } = this.props;
    if (suggestion) {
      await this.props.getCompanyNumbers(
        this.token,
        suggestion._id,
        false,
        'companyGroupAdmin',
        true,
      );
      await this.props.getCompanyGroupManager(
        this.token,
        suggestion._id,
        false,
        'companyGroupManager',
        true,
      );
      await this.props.getSupportEngineers(
        this.token,
        suggestion._id,
        false,
        'supportEngineer',
        true,
      );
      addNumberFieldChange(name, suggestion._id);
      addEmailFieldChange(this.props.email.emails);
      addNumberFieldChange('assignedTo', { email: this.props.emails[0], _id: user._id });
      addCompanyGroupChange({ name: 'company', value: suggestion._id });
    } else {
      addEmailFieldChange([]);
      addNumberFieldChange('company', value);
      addNumberFieldChange('userName', '');
      addCompanyGroupChange({ name: 'company', value: '' });
    }
  };

  onEmailsChange = emails => {
    const { addCompanyGroupChange } = this.props;
    const target = {
      name: 'notificationMails',
      value: emails,
    };
    this.setState(
      {
        notificationMails: emails,
      },
      () => {
        addCompanyGroupChange(target);
      },
    );
  };

  render() {
    const {
      addCompanyGroupChange,
      companies,
      companyGroupData,
      emails,
      number,
      suppportEmails,
      groupManagerEmail,
      companyFilter,
    } = this.props;
    return (
      <div className="container">
        <FormGroup row>
          <Label for="name" sm={6}>
            Group Name:
          </Label>
          <Col sm={8}>
            <Input
              required
              placeholder="Group Name..."
              type="text"
              name="name"
              value={this.state.name}
              onChange={this.handleChange}
            />
          </Col>
        </FormGroup>

        <FormGroup row>
          <Label for="name" sm={6}>
            Group:
          </Label>
          <Col sm={8}>
            <DropdownSelect
              options={groupItems}
              selectedOption={this.state.hostTag}
              onSelect={value => {
                this.setState({ hostTag: value });
                addCompanyGroupChange({ name: 'hostTag', value: value.value });
              }}
            />
          </Col>
        </FormGroup>

        <FormGroup row>
          <Label for="company" sm={6}>
            Management Company:
          </Label>
          <Col sm={8}>
            <CompanyAutocomplete
              placeholder="Filter Company..."
              companies={companies.docs || []}
              onChange={this.onAddedCompanyChange}
            />
          </Col>
        </FormGroup>
        {/* <FormGroup row>
          <Label for="type" sm={6}>
            Group Admin(s):
          </Label>
          <Col sm={8}>
            {companyGroupData.groupSuperAdmins && (
              <div className="email-list">{this.renderEmails()}</div>
            )}
            {emails.length !== 0 ? (
              <UsersAutocomplete
                callsItem={number.userName}
                placeholder="Group Admin..."
                calls={emails || []}
                onChange={this.onUserTypeSelect}
              />
            ) : companyGroupData.company && companyGroupData.company !== '' ? (
              <Alert colSpan={2} color="info" className="price-not-found-alert">
                No Group Admin(s) Found
              </Alert>
            ) : (
              <Alert colSpan={2} color="info" className="price-not-found-alert">
                Choose the company
              </Alert>
            )}
          </Col>
        </FormGroup> */}

        {/* <FormGroup row>
          <Label for="type" sm={4}>
            Support Engineer(s):
          </Label>
          <Col sm={8}>
            {this.state.supportEngineer?.length > 0 && (
              <div className="email-list">{this.renderSupport()}</div>
            )}
            {suppportEmails.emails?.length !== 0 ? (
              <UsersAutocomplete
                callsItem={number.userName}
                placeholder="Support Engineer..."
                calls={suppportEmails.emails || []}
                onChange={this.onSupportTypeSelect}
              />
            ) : companyGroupData.company && companyGroupData.company !== '' ? (
              <Alert colSpan={2} color="info" className="price-not-found-alert">
                No Support Engineer Found
              </Alert>
            ) : (
              <Alert colSpan={2} color="info" className="price-not-found-alert">
                Choose Support Engineer
              </Alert>
            )}
          </Col>
        </FormGroup> */}

        {/* <FormGroup row>
          <Label for="type" sm={6}>
            Group Manager(s):
          </Label>
          <Col sm={8}>
            {companyGroupData.groupManagers && (
              <div className="email-list">{this.renderManagerEmails()}</div>
            )}
            {groupManagerEmail.emails.length !== 0 ? (
              <UsersAutocomplete
                callsItem={number.userName}
                placeholder="Group Manager..."
                calls={groupManagerEmail.emails || []}
                onChange={this.onManagerSelect}
              />
            ) : companyGroupData.company && companyGroupData.company !== '' ? (
              <Alert colSpan={2} color="info" className="price-not-found-alert">
                No Group Manager(s) Found
              </Alert>
            ) : (
              <Alert colSpan={2} color="info" className="price-not-found-alert">
                Choose the company
              </Alert>
            )}
          </Col>
        </FormGroup> */}

        {/* <FormGroup row>
          <Label for="companies" sm={6}>
            Companies:
          </Label>
          <Col sm={8}>
            <div className="multi-input">
              {companyGroupData.managedCompanies && (
                <div className="email-list">{this.renderCompanies()}</div>
              )}
              {companies.docs && (
                <CompanyAutocomplete
                  multiSection={true}
                  searchTerm={companyFilter.value}
                  placeholder="Filter Company..."
                  companies={companies.docs}
                  onChange={this.textSearchFilter}
                />
              )}
            </div>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col sm={12}>
            <hr />
          </Col>
          <Label for="AlertContacts" sm={6}>
            Alert Contacts:
          </Label>
          <Col sm={8}>
            <MultiInput
              placeholder="Enter the email"
              inputData={this.state.notificationMails}
              onChange={this.onEmailsChange}
              validator={util.validateEmail}
            />
          </Col>
        </FormGroup> */}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.AppState.user,
    name: state.UIState.companies.addedCompany.name,
    status: state.UIState.companies.addedCompany.enabled,
    editData: state.UIState.companies.editCompanyData,
    editPermissions: state.UIState.companies.editCompanyData.permissions || '',
    companyFilter: state.UIState.epikBoxes.companyFilter,
    companyGroupData: state.UIState.companies.addCompanyGroupChange || '',
    companies: state.AppState.companies,
    emails: state.UIState.numbers.addNumberFieldChange,
    email: state.UIState.numbers.filterNumbersByCompany.number,
    groupManagerEmail: state.UIState.companies.filterByCompanyGroupManager.groupManagerEmail || [],
    suppportEmails: state.UIState.companies.filterBySupportEngineer.groupSupportEngineer || [],
    number: state.UIState.numbers.addNumber,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addCompanyGroupChange: companyData => dispatch(addCompanyGroupChange(companyData)),
    addNumberFieldChange: (name, value) => dispatch(addNumberFieldChange(name, value)),
    addEmailFieldChange: emails => dispatch(addEmailFieldChange(emails)),
    getCompanyNumbers: (token, id, uid, type, gflag) =>
      dispatch(getCompanyNumbers(token, id, uid, type, gflag)),
    getCompanyGroupManager: (token, id, uid, type, gflag) =>
      dispatch(getCompanyGroupManager(token, id, uid, type, gflag)),
    getSupportEngineers: (token, id, uid, type, gflag) =>
      dispatch(getSupportEngineers(token, id, uid, type, gflag)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddCompanyGroupForm);
